export const Permission = {
  HideHelpCenter: 'HIDE_HELP_CENTER',
  ShowOrdersSummaryView: 'SHOW_ORDER_SUMMARY_VIEW',
  CanInteractWithChatbot: 'CAN_INTERACT_WITH_CHATBOT',
  CanInteractWithStatisticChatbot: 'CAN_INTERACT_WITH_STATISTIC_CHATBOT'
};
